import React, { useEffect } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { animalAction, partoAction, fazendaAction, touroAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import './styles.css';
import '././styles.css';
import Select from 'react-select';
import Swal from 'sweetalert2';

const PartoEdit = (props) => {

    const dispatch = useDispatch();

    useEffect(() => {
        const { match: { params } } = props;
        const { dispatch } = props;

        dispatch(fazendaAction.getFazendaSelect());
        if (params.id) {
            dispatch(partoAction.getPartoById(params.id, true));
        }

    }, []);

    useEffect(() => {

        if (props.parto.id_fazenda !== '0') {
            dispatch(animalAction.getAnimalByFazendaSelect(props.parto.id_fazenda));
            dispatch(touroAction.getTouroByFazendaSelect(props.parto.id_fazenda));
        }
        else {
            dispatch(animalAction.clear());
            dispatch(touroAction.clear());
        }


    }, [props.parto.id_fazenda]);

    useEffect(() => {
        renderOptionsAnimal();
    }, [props.animal.animal]);

    useEffect(() => {
        renderOptionsTouro();
    }, [props.touro.touro]);

    const handleSelectChange = prop => event => {

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(partoAction.onChangeProps(prop, event2));

    };

    const handleChange = prop => event => {
        dispatch(partoAction.onChangeProps(prop, event));
    };

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (props.parto.data === null || props.parto.data === '') {
            valid = false;
            errors += '<li style="float:left;">Informe uma Data válida!</li><br>';
        }
        if (props.parto.id_fazenda === null || props.parto.id_fazenda === '' || props.parto.id_fazenda === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe uma Fazenda válida!</li><br>';
        }
        if (props.parto.id_touro === null || props.parto.id_touro === '' || props.parto.id_touro === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um Touro válido!</li><br>';
        }
        if (props.parto.id_animal === null || props.parto.id_animal === '' || props.parto.id_animal === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um Animal válido!</li><br>';
        }
        if (props.parto.tipo === null || props.parto.tipo === '' || props.parto.tipo === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um Tipo de parto válido!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }

        return valid;

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                id_animal: props.parto.id_animal,
                data: props.parto.data,
                id_fazenda: props.parto.id_fazenda,
                id_touro: props.parto.id_touro,
                tipo: props.parto.tipo,
                valido: props.parto.valido,
                nascido_morto: props.parto.nascido_morto,
                usuario_cadastro: props.authentication.user.id
            }

            if (params.id) {
                dispatch(partoAction.editPartoInfo(params.id, payload));
            } else {
                dispatch(partoAction.createParto(payload));
            }

        }

    };


    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const renderOptionsAnimal = () => {
        return props.animal.animal.map((p, i) => {
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };


    const renderOptionsTouro = () => {
        return props.touro.touro.map((p, i) => {
            return (
                { value: p.Value, label: p.Text }
            );
        });
    };

    const renderOptionsTipoParto = () => {
        var tipoData = [
            { value: '', name: 'SELECIONE...' },
            { value: 'A', name: 'Aborto' },
            { value: 'I', name: 'Indução' },
            { value: 'M', name: 'Macho' },
            { value: 'F', name: 'Fêmea' },
            { value: 'MM', name: 'Gêmeos machos' },
            { value: 'FF', name: 'Gêmeas fêmeas' },
            { value: 'MF', name: 'Gêmeos macho e fêmea' }
        ];
        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.name }
            );
        });
    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/partos">Lista de Partos</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Parto {props.parto.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="data">Data *</Label>
                                        <Input
                                            id="data"
                                            label="Data *"
                                            className="form-control"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={props.parto.data}
                                            onChange={handleChange('data')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="id_fazenda">Fazenda *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsFazenda().filter(function (option) {
                                                return option.value === (props.parto.id_fazenda || '0');
                                            })}
                                            onChange={handleSelectChange('id_fazenda')}
                                            isSearchable
                                            placeholder="Selecione..."
                                            id="id_fazenda"
                                            name="id_fazenda"
                                            options={renderOptionsFazenda()}
                                        />

                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup check>
                                        <Label className="left" for="nascidoMorto" check>Nascido Morto
                                            <Input
                                                id="nascidoMorto"
                                                label="Nascido Morto"
                                                type="checkbox"
                                                checked={props.parto.nascidoMorto || false}
                                                onChange={handleChange('nascidoMorto')}
                                            />
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup check>
                                        <Label className="left" for="valido" check>Válido
                                            <Input
                                                id="valido"
                                                label="Válido"
                                                type="checkbox"
                                                checked={props.parto.valido || false}
                                                onChange={handleChange('valido')}
                                            />
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="left" for="id_touro">Touro *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsTouro().filter(function (option) {
                                                return option.value === (props.parto.id_touro || '0');
                                            })}
                                            placeholder="Selecione..."
                                            onChange={handleSelectChange('id_touro')}
                                            isSearchable
                                            id="id_touro"
                                            name="id_touro"
                                            isDisabled={props.parto.id_fazenda === '0' || props.parto.id_fazenda === ''}
                                            options={renderOptionsTouro()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="left" for="id_animal">Animal *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsAnimal().filter(function (option) {
                                                return option.value === (props.parto.id_animal || '0');
                                            })}
                                            onChange={handleSelectChange('id_animal')}
                                            isSearchable
                                            id="id_animal"
                                            placeholder="Selecione..."
                                            name="id_animal"
                                            isDisabled={props.parto.id_fazenda === '0' || props.parto.id_fazenda === ''}
                                            options={renderOptionsAnimal()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="left" for="tipo">Tipo de Parto *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsTipoParto().filter(function (option) {
                                                return option.value === (props.parto.tipo || '');
                                            })}
                                            placeholder="Selecione..."
                                            onChange={handleSelectChange('tipo')}
                                            isSearchable
                                            id="tipo"
                                            name="tipo"
                                            options={renderOptionsTipoParto()}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/partos">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button variant="contained" className="mr-1" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );

}

const mapStateToProps = (state) => {
    return state;
}

const connectedPartoEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(PartoEdit));
export { connectedPartoEditPage as PartoEdit };